/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { LineItemReturnModel } from './LineItemReturnModel';
import {
    LineItemReturnModelFromJSON,
    LineItemReturnModelFromJSONTyped,
    LineItemReturnModelToJSON,
} from './LineItemReturnModel';
import type { Money } from './Money';
import {
    MoneyFromJSON,
    MoneyFromJSONTyped,
    MoneyToJSON,
} from './Money';
import type { OrderPaymentInformation } from './OrderPaymentInformation';
import {
    OrderPaymentInformationFromJSON,
    OrderPaymentInformationFromJSONTyped,
    OrderPaymentInformationToJSON,
} from './OrderPaymentInformation';
import type { PaymentTerms } from './PaymentTerms';
import {
    PaymentTermsFromJSON,
    PaymentTermsFromJSONTyped,
    PaymentTermsToJSON,
} from './PaymentTerms';
import type { ShipmentReturnModel } from './ShipmentReturnModel';
import {
    ShipmentReturnModelFromJSON,
    ShipmentReturnModelFromJSONTyped,
    ShipmentReturnModelToJSON,
} from './ShipmentReturnModel';

/**
 * 
 * @export
 * @interface OrderModel
 */
export interface OrderModel {
    /**
     * 
     * @type {string}
     * @memberof OrderModel
     */
    orderId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderModel
     */
    marketId?: string;
    /**
     * 
     * @type {Array<LineItemReturnModel>}
     * @memberof OrderModel
     */
    lines?: Array<LineItemReturnModel>;
    /**
     * 
     * @type {Address}
     * @memberof OrderModel
     */
    billingAddress?: Address;
    /**
     * 
     * @type {Address}
     * @memberof OrderModel
     */
    shippingAddress?: Address;
    /**
     * 
     * @type {boolean}
     * @memberof OrderModel
     */
    useBillingAddressForShipping?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderModel
     */
    note?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderModel
     */
    acceptNewsletter?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderModel
     */
    acceptTerms?: boolean;
    /**
     * 
     * @type {Money}
     * @memberof OrderModel
     */
    subtotal?: Money;
    /**
     * 
     * @type {Money}
     * @memberof OrderModel
     */
    total?: Money;
    /**
     * 
     * @type {Money}
     * @memberof OrderModel
     */
    shippingTotal?: Money;
    /**
     * 
     * @type {Money}
     * @memberof OrderModel
     */
    totalVat?: Money;
    /**
     * 
     * @type {Money}
     * @memberof OrderModel
     */
    shippingVat?: Money;
    /**
     * 
     * @type {Money}
     * @memberof OrderModel
     */
    totalDiscount?: Money;
    /**
     * 
     * @type {string}
     * @memberof OrderModel
     */
    currency?: string;
    /**
     * 
     * @type {PaymentTerms}
     * @memberof OrderModel
     */
    paymentTerms?: PaymentTerms;
    /**
     * 
     * @type {string}
     * @memberof OrderModel
     */
    orderNumber?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderModel
     */
    promoCodes?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof OrderModel
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrderModel
     */
    updated?: Date;
    /**
     * 
     * @type {string}
     * @memberof OrderModel
     */
    orderState?: string;
    /**
     * 
     * @type {OrderPaymentInformation}
     * @memberof OrderModel
     */
    paymentInformation?: OrderPaymentInformation;
    /**
     * 
     * @type {Array<ShipmentReturnModel>}
     * @memberof OrderModel
     */
    shipments?: Array<ShipmentReturnModel>;
}

/**
 * Check if a given object implements the OrderModel interface.
 */
export function instanceOfOrderModel(value: object): boolean {
    return true;
}

export function OrderModelFromJSON(json: any): OrderModel {
    return OrderModelFromJSONTyped(json, false);
}

export function OrderModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderModel {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'marketId': json['marketId'] == null ? undefined : json['marketId'],
        'lines': json['lines'] == null ? undefined : ((json['lines'] as Array<any>).map(LineItemReturnModelFromJSON)),
        'billingAddress': json['billingAddress'] == null ? undefined : AddressFromJSON(json['billingAddress']),
        'shippingAddress': json['shippingAddress'] == null ? undefined : AddressFromJSON(json['shippingAddress']),
        'useBillingAddressForShipping': json['useBillingAddressForShipping'] == null ? undefined : json['useBillingAddressForShipping'],
        'note': json['note'] == null ? undefined : json['note'],
        'acceptNewsletter': json['acceptNewsletter'] == null ? undefined : json['acceptNewsletter'],
        'acceptTerms': json['acceptTerms'] == null ? undefined : json['acceptTerms'],
        'subtotal': json['subtotal'] == null ? undefined : MoneyFromJSON(json['subtotal']),
        'total': json['total'] == null ? undefined : MoneyFromJSON(json['total']),
        'shippingTotal': json['shippingTotal'] == null ? undefined : MoneyFromJSON(json['shippingTotal']),
        'totalVat': json['totalVat'] == null ? undefined : MoneyFromJSON(json['totalVat']),
        'shippingVat': json['shippingVat'] == null ? undefined : MoneyFromJSON(json['shippingVat']),
        'totalDiscount': json['totalDiscount'] == null ? undefined : MoneyFromJSON(json['totalDiscount']),
        'currency': json['currency'] == null ? undefined : json['currency'],
        'paymentTerms': json['paymentTerms'] == null ? undefined : PaymentTermsFromJSON(json['paymentTerms']),
        'orderNumber': json['orderNumber'] == null ? undefined : json['orderNumber'],
        'promoCodes': json['promoCodes'] == null ? undefined : json['promoCodes'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'orderState': json['orderState'] == null ? undefined : json['orderState'],
        'paymentInformation': json['paymentInformation'] == null ? undefined : OrderPaymentInformationFromJSON(json['paymentInformation']),
        'shipments': json['shipments'] == null ? undefined : ((json['shipments'] as Array<any>).map(ShipmentReturnModelFromJSON)),
    };
}

export function OrderModelToJSON(value?: OrderModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'orderId': value['orderId'],
        'marketId': value['marketId'],
        'lines': value['lines'] == null ? undefined : ((value['lines'] as Array<any>).map(LineItemReturnModelToJSON)),
        'billingAddress': AddressToJSON(value['billingAddress']),
        'shippingAddress': AddressToJSON(value['shippingAddress']),
        'useBillingAddressForShipping': value['useBillingAddressForShipping'],
        'note': value['note'],
        'acceptNewsletter': value['acceptNewsletter'],
        'acceptTerms': value['acceptTerms'],
        'subtotal': MoneyToJSON(value['subtotal']),
        'total': MoneyToJSON(value['total']),
        'shippingTotal': MoneyToJSON(value['shippingTotal']),
        'totalVat': MoneyToJSON(value['totalVat']),
        'shippingVat': MoneyToJSON(value['shippingVat']),
        'totalDiscount': MoneyToJSON(value['totalDiscount']),
        'currency': value['currency'],
        'paymentTerms': PaymentTermsToJSON(value['paymentTerms']),
        'orderNumber': value['orderNumber'],
        'promoCodes': value['promoCodes'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'orderState': value['orderState'],
        'paymentInformation': OrderPaymentInformationToJSON(value['paymentInformation']),
        'shipments': value['shipments'] == null ? undefined : ((value['shipments'] as Array<any>).map(ShipmentReturnModelToJSON)),
    };
}

